import { NavLink } from "react-router-dom";
import { appName, appTagline } from "../common";

const Navbar = () => {
    return (
        <nav className="navbar">
            <div className="brand">
                <h2 className="logo">{appName}</h2>
                <p className="brand-tagline">{appTagline}</p>
            </div>
            <ul>
                <li><NavLink to="/" end>Home</NavLink></li>
                <li><NavLink to="/about">About Us</NavLink></li>
                <li><NavLink to="/gallery">Gallery</NavLink></li>
                <li><NavLink to="/contact">Contact</NavLink></li>

            </ul>
        </nav>
    );
};

export default Navbar;
